import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./contexts/AuthContext";
import { FeatureProvider } from "./contexts/FeatureContext";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import PublicLayout from "./components/marketing/PublicLayout";
import HomePage from "./components/marketing/HomePage";
import ProductPage from "./components/marketing/ProductPage";
import ContactPage from "./components/marketing/ContactPage";
import AuthPage from "./components/auth/AuthPage";
import UpdatePasswordScreen from "./components/auth/UpdatePasswordScreen";
import DashboardLayout from "./components/layout/DashboardLayout";
import CreateTournamentTab from "./components/create/CreateTournamentTab";
import PlayTournament from "./components/play/PlayTournament";
import TournamentsPage from "./components/tournaments/TournamentsPage";
import PlayersPage from "./components/players/PlayersPage";
import StatisticsPage from "./components/statistics/StatisticsPage";
import SettingsPage from "./components/settings/SettingsPage";
import "./styles/theme.css";
import "./styles/dashboard.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <FeatureProvider>
          <AuthProvider>
            <Routes>
              {/* ── Public marketing zone ── */}
              <Route element={<PublicLayout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/product" element={<ProductPage />} />
                <Route path="/contact" element={<ContactPage />} />
              </Route>

              {/* ── Auth ── */}
              <Route path="/sign-in" element={<AuthPage />} />
              <Route path="/update-password" element={<UpdatePasswordScreen />} />

              {/* ── Application zone (login required) ── */}
              <Route
                path="/app"
                element={
                  <ProtectedRoute>
                    <DashboardLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Navigate to="create" replace />} />
                <Route path="create" element={<CreateTournamentTab />} />
                <Route path="play/:id" element={<PlayTournament />} />
                <Route path="tournaments" element={<TournamentsPage />} />
                <Route path="players" element={<PlayersPage />} />
                <Route path="statistics" element={<StatisticsPage />} />
                <Route path="settings" element={<SettingsPage />} />
              </Route>

              {/* ── Fallback ── */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AuthProvider>
        </FeatureProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}

export default App;
